export { default } from './ShelfList';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfList/index.js